<div class="file-details-grid">
  <!-- Empty State -->
  @if (fileDetails.length === 0) {
    <div class="empty-state">
      <p>No file details available for this request.</p>
    </div>
  }

  <!-- Data Table -->
  @if (fileDetails.length > 0) {
    <div class="table-wrapper">
      <table class="file-table">
        <thead>
          <tr>
            <th>File Name</th>
            <th>Status</th>
            <th class="numeric">Check Count</th>
            <th class="numeric">DDA Count</th>
            <th class="numeric">Docs in File</th>
            <th class="numeric">Total Amount of Docs</th>
            <th class="numeric">File Number</th>
            @if (showReadyToProcess) {
              <th>Ready to Process</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (file of fileDetails; track file) {
            <tr
              (click)="onFileRowClick(file)"
              (keydown.enter)="onFileRowClick(file)"
              (keydown.space)="onFileRowClick(file)"
              [attr.tabindex]="canOpenFileDetails ? 0 : null"
              [attr.role]="canOpenFileDetails ? 'button' : null"
              [class.clickable-row]="canOpenFileDetails">
              <td class="filename-cell" [title]="file.fileName">
                {{ file.fileName }}
              </td>
              <td>
                <span
                  class="status-badge"
                  [ngClass]="getStatusClass(file.status)">
                  {{ file.fileStatusName }}
                </span>
              </td>
              <td class="numeric">{{ file.checkCount }}</td>
              <td class="numeric">{{ file.ddaCount }}</td>
              <td class="numeric">{{ file.docsInFile }}</td>
              <td class="numeric">{{ file.totalAmountOfDocs }}</td>
              <td class="numeric">{{ file.fileNumber }}</td>
              @if (showReadyToProcess) {
                <td>
                  <span
                    class="boolean-cell"
                    [class.is-true]="file.readyToProcess">
                    {{
                      file.readyToProcess
                        ? formatBooleanYes()
                        : formatBooleanNo()
                    }}
                  </span>
                </td>
              }
            </tr>
          }
        </tbody>
        <tfoot>
          <tr class="totals-row">
            <td colspan="2"><strong>Totals</strong></td>
            <td class="numeric">
              <strong>{{ totals.checkCount }}</strong>
            </td>
            <td class="numeric">
              <strong>{{ totals.ddaCount }}</strong>
            </td>
            <td class="numeric">
              <strong>{{ totals.docsInFile }}</strong>
            </td>
            <td class="numeric">
              <strong>{{ totals.totalAmountOfDocs }}</strong>
            </td>
            <td [attr.colspan]="showReadyToProcess ? 2 : 1"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  }
</div>
